import Swiper from "swiper/bundle";

class GalleryArbitrary {
  constructor(args = { sectionsContainer: document }) {
    this.sectionsContainer = args.sectionsContainer;
    this.sliderGallerySections = Array.from(this.sectionsContainer.getElementsByClassName("gallery-arbitrary"));
    this.swiperInstances = [];
    if (this.sliderGallerySections != null) {
      this.initializeSwiper();
      this.addResizeListener();
    } else {
      this.instance = null;
    }
  }

  initializeSwiper() {
    //console.log(this.sliderGallerySections);
    if (!this.sliderGallerySections[0]) {
      return;
    }
    
    this.sliderGallerySections.forEach((section) => {
      const swiperContainer = section.querySelector(".swiper-container");
      this.swiperInstances.push(new Swiper(swiperContainer, {
          grabCursor: true,
          loop: false,
          slidesPerView: this.getSlidesPerView(),
          //centeredSlides: true,
          spaceBetween: 20,
          pagination: {
            el: section.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev'),
          }
      }));
    });
    //console.log(this.swiperInstances);
  }

  addResizeListener() {
    window.addEventListener('resize', () => {
      if (this.swiperInstances) {
        this.swiperInstances.forEach((instance) => {
          instance.params.slidesPerView = this.getSlidesPerView();
          instance.update();
        });
      }
    });
  }

  getSlidesPerView() {
    const width = window.innerWidth;
    if (width <= 576) {
      return 1.1;
    } else if (width <= 1024) {
      return 2.2;
    } else {
      return 3.2;
    }
  }

  /*handleSlideChange() {
    // Seleccionamos todas las diapositivas del swiper
    const slides = this.swiperInstance.slides;
    const activeIndex = this.swiperInstance.activeIndex;
    const totalSlides = slides.length;

    // Hacemos visibles todas las diapositivas
    slides.forEach(slide => {
      slide.style.visibility = 'visible';
    });

    // Ocultamos las diapositivas que ya se han desplazado a la izquierda
    for (let i = 0; i < activeIndex; i++) {
      const slide = slides[i];
      slide.style.visibility = 'hidden';
      //slide.style.marginRight = 0;
    }

    // Ocultamos las diapositivas que han salido de la vista por la derecha
    for (let i = activeIndex + this.swiperInstance.params.slidesPerView; i < totalSlides; i++) {
      const slide = slides[i];
      slide.style.visibility = 'hidden';
    }
  }*/
}

export default GalleryArbitrary;


